<h2 mat-dialog-title>{{ dialogData.title | translate }}</h2>
<mat-dialog-content>
  @if (dialogData.message) {
  <span class="message" [innerHTML]="dialogData.message | translate"></span>
  } @if (form) {
  <form [formGroup]="form" class="mt-2">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ dialogData.prompt?.label ?? '' | translate }}</mat-label>
      <input matInput type="text" [placeholder]="dialogData.prompt?.placeholder ?? '' | translate" formControlName="value" />
    </mat-form-field>
  </form>
  }
</mat-dialog-content>

<mat-dialog-actions class="row mt-1 justify-content-end">
  @if (dialogData.cancelText) {
  <button mat-flat-button (click)="onCancel()">
    {{ dialogData.cancelText | translate }}
  </button>
  } @if (dialogData.okText) {
  <button mat-flat-button [disabled]="!!form && !form.valid" (click)="onOk()" class="ml-3" [color]="okButtonType">
    {{ dialogData.okText | translate }}
  </button>
  }
</mat-dialog-actions>
